(function ($)
{
	window.Overlay = function (sType) {
		this._inputData = {
			Type:sType || this.Type,
			Uid: InteractiveChart.GetGUID()
		};
	};
	Overlay.prototype.Type = "0";
	Overlay.prototype.GetInputData = function () {
		return this._inputData;
	};
	Overlay.prototype.SetInput = function (sName, sValue) {
		this._inputData[sName] = sValue;
	};
	Overlay.prototype.GetInput = function (sName) {
		return this._inputData[sName];
	};
	Overlay.prototype.GetUID = function () {
		return this._inputData.Uid;
	};

	// used for extra params, such as "Period" for SMA
	Overlay.prototype.GetAllParameters = function () {
		return this._inputData.Parameters || {};
	};

	Overlay.prototype.SetParameter = function (sName, sValue) {
		this._inputData.Parameters = this.GetAllParameters();
		this._inputData.Parameters[sName] = sValue;
	};
	Overlay.prototype.GetParameter = function (sName) {
		var parameters = this.GetAllParameters();
		return parameters[sName] || "";
	};
	Overlay.prototype.GetInputs = function () {
		return this._inputData;
	};
})(jQuery);